import { HeadCell, ACTION } from '../../../../component/table/interfaces/TableInterface';

export const HEAD_CELL: Array<HeadCell> = [
    { id: 'Nome', label: 'Nome do grupo' },
    { id: 'ActiveDirectory', label: 'Tipo do grupo', viewAttributeBoolean: { primaryLabel: 'AD', secundaryLabel: 'Local' } },
    { id: ACTION, label: 'Ação' }
];